import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/hooks';
import { deepCopy } from '../../../../../common/services/common.service';
import { selectCurrent } from '../../../../../redux/settings/selectors';
import { settings } from '../../../../../redux/settings/actions';
import UploadFiles from '../../../../../models/UploadFile';
import PageLoader from '../../../../../components/PageLoader';
import { selectdigitalPublicInfrastructuresListItems, selectdigitalPublicInfrastructuresQueryItems } from '../../../../../redux/digital-public-infrastructures/selector';
import { digitalPublicInfrastructures } from '../../../../../redux/digital-public-infrastructures/action';
import DigitalPublicInfrastructureComponent from '../components/digital-public-infrastructure-component';



let currentChange: any = {}
const DigitalPublicInfrastructure= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectdigitalPublicInfrastructuresQueryItems)
  const digitalPublicInfrastructuresItems = useSelector(selectdigitalPublicInfrastructuresListItems)
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  
  
const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedDigitalPublicInfrastructure,
    setSelectedDigitalPublicInfrastructure
  ] = useState<any>({
    MediaMappings: {
      MediaFiles: [],
      Templates: []
    }
  })
  const [
    digitalPublicInfrastructureImageIndex,
    setDigitalPublicInfrastructureImageIndex
  ] = useState<any>([])
  const [
    mediaFiles,
    setMediaFiles
  ] = useState<any>([])
  const [
    openFile,
    setOpenFile
  ] = useState<any>([]);
 
  const handleFormItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(mediaFiles);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMediaFiles(items);
  }


  const fetchDigitalPublicInfrastructureById= ()=>{
    dispatch(digitalPublicInfrastructures.query({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/digital-public-infrastructures/query`,entity:'digitalPublicInfrastructures',jsonData:{
          
    Records: [
      {
        
          
              "Id": parmas?.id
          
      
       
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedDigitalPublicInfrastructure({ ...selectedDigitalPublicInfrastructure, [field]: event });
  }

  useEffect(
    () => {
      dispatch(digitalPublicInfrastructures.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/digital-Public-infrastructures/list`,entity:'services',jsonData:{}}))
      .then(()=>{
      if (parmas?.id > 0) {
        fetchDigitalPublicInfrastructureById()
        setIsLoading(false)
    }else {
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
        setMediaFiles(localSelectedMedia)
        setIsLoading(false)
      }
    })
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedDigitalPublicInfrastructure(queryItems?.result?.items)
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: queryItems?.result?.items?.MediaMappings?.MediaFiles });
        setMediaFiles(localSelectedMedia)
      }
    },
    [isQuery]
  )
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    mediaFiles.splice(
        mediaFiles.length - 1,
        1
      )

      const updatedData = {
        ...selectedDigitalPublicInfrastructure,
        MediaMappings: {MediaFiles: mediaFiles, Templates: selectedDigitalPublicInfrastructure?.MediaMappings?.Templates},
    };
    if (parmas?.id > 0) {
     await dispatch(digitalPublicInfrastructures.resetAction({ actionType: 'update' }))
     await dispatch(digitalPublicInfrastructures.update({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/digital-public-infrastructures`,entity:'digitalPublicInfrastructures',jsonData:{
          
    Records: [
      updatedData
      
    ]
 
}})).then(()=>{
  back()
})

    }else{
      await dispatch(digitalPublicInfrastructures.resetAction({ actionType: 'create' }))
      await dispatch(digitalPublicInfrastructures.create({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/digital-public-infrastructures`,entity:'digitalPublicInfrastructures',jsonData:{
          
      Records: [
        updatedData
      ]
    
  }})).then(()=>{
    back()
  })
    }

  }

const back=()=>{
  navigate('/management/dbaas/digital-public-infrastructures')
} 
const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
    const localSelectedmedia = deepCopy(selectedMediaFilesArg)
    const newsSelectedMedia = {
      Id: 0,
      FileTypeId: 0,
      OwnerTypeId: 148,
      FileMappingURL: ''
    }
    if (localSelectedmedia.length === 0 ||
      localSelectedmedia[localSelectedmedia?.length - 1]?.FileTypeId !== 0
    ) {
      localSelectedmedia?.push(newsSelectedMedia)
    }
  
    return localSelectedmedia
  }
  const setCombinationInfo = async () => {
    let localSelectedMedia = deepCopy(mediaFiles)
    localSelectedMedia.splice(
      currentChange.idx,
      1,
      { ...localSelectedMedia[currentChange.idx] }
    );
    localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
    currentChange.field = 'FileTypeIdDONE'
    setMediaFiles(localSelectedMedia)
  }
  const changeImage = (idx: number, templateField: any, fileType: any) => {
    setDigitalPublicInfrastructureImageIndex(idx)
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenFile({
      currentFileSrc: mediaFiles[idx][templateField],
      folder: 'digitalpublicinfrastructure',
      type: fileType
    })
  }
  const handleSubmit = (data: any) => {
  
    mediaFiles[digitalPublicInfrastructureImageIndex].FileMappingURL = data
    const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
    setMediaFiles(localSelectedMedia)
  }
  const handleClose = () => {
    dispatch(settings.set({ getUploadFiles: 'close' }))
    
  }
  
  useEffect(
    () => {
      if (currentChange.field === 'FileTypeId') {
        setCombinationInfo()
      }
    },
    [mediaFiles]
  )
  
    return (
    <>
     {getUploadFiles == 'open' && <UploadFiles  currentFilesSrc={openFile?.currentFileSrc}
    folder={openFile?.folder}
         handleClose={handleClose}
         handleFilesSubmit={handleSubmit}
         type={openFile?.type}
         ownerId={parmas?.id}
         />}
    {isLoading ? <PageLoader /> : 
          <DigitalPublicInfrastructureComponent 
           handleInnerFormChange={handleInnerFormChange}
           selectedDigitalPublicInfrastructure={selectedDigitalPublicInfrastructure}
           back={back}
           handleFormSubmit={handleFormSubmit}
           changeImage={changeImage}
           mediaFiles={mediaFiles}
           handleFormItemChange={handleFormItemChange}
           digitalPublicInfrastructure={digitalPublicInfrastructuresItems?.result?.items}
          />  
        }
    
          </>
    )
    
    }
   
    export default DigitalPublicInfrastructure;
